import React, { useState, useEffect } from 'react'
import {
  Box,
  Button,
  FormControlLabel,
  Switch,
  TextField,
  Typography,
  makeStyles,
} from '@material-ui/core'
import RichTextField from './RichTextField'
import { getIntroBodyHtml } from '../utils/introRichText'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
  signatureRow: {
    display: 'flex',
    gap: theme.spacing(2),
  },
  signatureBox: {
    border: '1px solid #ddd',
    borderRadius: 6,
    padding: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
  signatureHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
  },
  logoHint: {
    fontSize: 12,
    color: '#777',
  },
}))

const BlurField = ({ value, onCommit, ...props }) => {
  const [local, setLocal] = useState(value || '')
  useEffect(() => { setLocal(value || '') }, [value])
  return (
    <TextField
      {...props}
      value={local}
      onChange={(e) => setLocal(e.target.value)}
      onBlur={() => { if (local !== (value || '')) onCommit(local) }}
    />
  )
}

const IntroEditor = ({ data, onChange, theme }) => {
  const classes = useStyles()
  const bodyHtml = getIntroBodyHtml(data)
  const signatureBlockEnabled = !!data.signatureBlockEnabled

  const applyPreparedByDefaults = () => {
    onChange('signatureName', '{{yourName}}')
    onChange('signatureTitle', '{{yourTitle}}')
    onChange('signaturePhone', '{{yourPhone}}')
    onChange('signatureMobile', '{{yourMobile}}')
    onChange('signatureEmail', '{{yourEmail}}')
    onChange('signatureLogoEnabled', true)
    onChange('signatureLogoUrl', '')
  }

  return (
    <Box className={classes.root}>
      <BlurField
        label="Greeting"
        value={data.greeting || ''}
        onCommit={(v) => onChange('greeting', v)}
        size="small"
        variant="outlined"
        fullWidth
      />

      <RichTextField
        label="Body"
        value={bodyHtml}
        onChange={(v) => onChange('bodyHtml', v)}
      />

      <BlurField
        label="Closing"
        value={data.closing || ''}
        onCommit={(v) => onChange('closing', v)}
        size="small"
        variant="outlined"
        fullWidth
      />

      <Box className={classes.signatureBox}>
        <Box className={classes.signatureHeader}>
          <FormControlLabel
            control={(
              <Switch
                checked={signatureBlockEnabled}
                onChange={(e) => onChange('signatureBlockEnabled', e.target.checked)}
                color="primary"
              />
            )}
            label="Signature block"
          />
          <Button size="small" variant="outlined" onClick={applyPreparedByDefaults}>
            Use prepared-by defaults
          </Button>
        </Box>

        {signatureBlockEnabled && (
          <>
            <Box className={classes.signatureRow}>
              <BlurField
                label="Name"
                value={data.signatureName || ''}
                onCommit={(v) => onChange('signatureName', v)}
                size="small"
                variant="outlined"
                fullWidth
              />
              <BlurField
                label="Title"
                value={data.signatureTitle || ''}
                onCommit={(v) => onChange('signatureTitle', v)}
                size="small"
                variant="outlined"
                fullWidth
              />
            </Box>
            <Box className={classes.signatureRow}>
              <BlurField
                label="Phone"
                value={data.signaturePhone || ''}
                onCommit={(v) => onChange('signaturePhone', v)}
                size="small"
                variant="outlined"
                fullWidth
              />
              <BlurField
                label="Mobile"
                value={data.signatureMobile || ''}
                onCommit={(v) => onChange('signatureMobile', v)}
                size="small"
                variant="outlined"
                fullWidth
              />
            </Box>
            <BlurField
              label="Email"
              value={data.signatureEmail || ''}
              onCommit={(v) => onChange('signatureEmail', v)}
              size="small"
              variant="outlined"
              fullWidth
            />
            <BlurField
              label="Logo URL"
              value={data.signatureLogoUrl || ''}
              onCommit={(v) => onChange('signatureLogoUrl', v)}
              size="small"
              variant="outlined"
              fullWidth
              placeholder={theme?.logoUrl || 'Uses entity logo when blank'}
            />
            <FormControlLabel
              control={(
                <Switch
                  checked={data.signatureLogoEnabled !== false}
                  onChange={(e) => onChange('signatureLogoEnabled', e.target.checked)}
                  color="primary"
                />
              )}
              label="Show logo in signature"
            />
            <Typography className={classes.logoHint}>
              Leave Logo URL blank to use the current entity/theme logo.
            </Typography>
          </>
        )}
      </Box>
    </Box>
  )
}

export default IntroEditor
